import React from 'react';
import PluginFindUser from './src/PluginFindUser';

export default props => <PluginFindUser {...props} />;
